import { BarChart2, Eye, ShieldAlert, TrendingDown } from "lucide-react";
import ApplicationPage, { type ApplicationPageConfig } from "@/components/ApplicationPage";

const config: ApplicationPageConfig = {
  key: "lossPrevention",
  slug: "prevencao-perdas",
  icon: TrendingDown,
  useCases: [
    { key: "inventory", icon: Eye },
    { key: "theft", icon: ShieldAlert },
    { key: "waste", icon: BarChart2 },
    { key: "costs", icon: TrendingDown },
  ],
  benefits: ["losses", "savings", "recurrence", "visibility"],
  formApplication: "Prevenção de Perdas",
};

const PrevencaoPerdas = () => <ApplicationPage config={config} />;

export default PrevencaoPerdas;
